import Component from '../Component';
import React from 'react';
import {Select} from 'reactis-inputs';
import DbInfo from '../../dbinfo';
import immutable from 'immutable';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';


export default class TagInput extends Component {

	constructor(){
		super();
		this.value = immutable.List();
	}

	componentDidMount() {
		$(ReactDOM.findDOMNode(this.refs.tag)).tagsinput({
			tagClass: 'tag-default'
		});

		$(ReactDOM.findDOMNode(this.refs.tag)).on('change', (e) => {
			if (!this.adding) {
				this.value = immutable.List($(e.target).tagsinput('items'));
				this.props.onChange(this.value);
			}
		});
		const el = $(ReactDOM.findDOMNode(this.refs.tag));
		if (this.props.value) {
			this.props.value.forEach((item) => el.tagsinput('add', item));
		}
	}

	componentWillReceiveProps({value}) {
		if (value != this.props.value) {
			const el = $(ReactDOM.findDOMNode(this.refs.tag));
			this.adding = true;
			el.tagsinput('removeAll');
			if (value) {
				value.forEach((item) => el.tagsinput('add', item));
			}
			this.adding = false;
		}
	}

	componentWillUnmount() {
		$(ReactDOM.findDOMNode(this.refs.tag)).tagsinput('destroy');
	}

	shouldComponentUpdate() {
		return false;
	}

	render() {
		return (
			<input ref="tag" />
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/TagInputBase.js